var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px-2"},[_c('button',{staticClass:"btn btn--nav my-2 w-100"},[_vm._v(_vm._s(_vm._f("title")(_vm.$t('org.showResults'))))])])}
var staticRenderFns = []

export { render, staticRenderFns }